const masterInitialState = {
    //category
    loadingCategoryDataListApi: false,
    CategoryDataListApiData: [],
    CategoryDataListApiError: '',

    //country
    loadingCountryDataListApi: false,
    CountryDataListApiData: [],
    CountryDataListApiError: '',

    //state
    loadingStateDataListApi: false,
    StateDataListApiData: [],
    StateDataListApiError: '',

    //city
    loadingCityDataListApi: false,
    CityDataListApiData: [],
    CityDataListApiError: '',

    // website management data
    loadingWebsiteManagementDataListApi: false,
    WebsiteManagementDataListApiData: [],
    WebsiteManagementDataListApiError: '',


    loadingPopularTutorDataListApi: false,
    PopularTutorDataListApiData: [],
    PopularTutorDataListApiError: '',


    loadingTestimonialDataListApi: false,
    TestimonialDataListApiData: [],
    TestimonialDataListApiError: '',


    loadingBecomeTutorThirdSectionDataListApi: false,
    BecomeTutorThirdSectionDataListApiData: [],
    BecomeTutorThirdSectionDataListApiError: '',


    loadingBlogDataListApi: false,
    BlogDataListApiData: [],
    BlogDataListApiError: '',

    loadingBlogCategoryDataListApi: false,
    BlogCategoryDataListApiData: [],
    BlogCategoryDataListApiError: '',

    loadingLatestBlogDataListApi: false,
    LatestBlogDataListApiData: [],
    LatestBlogDataListApiError: '',

    loadingBlogDetailDataListApi: false,
    BlogDetailDataListApiData: [],
    BlogDetailDataListApiError: '',


    loadingHomeTutorListDataListApi: false,
    HomeTutorListDataListApiData: [],
    HomeTutorListDataListApiError: '',

    loadingHomeTutorViewDataListApi: false,
    HomeTutorViewDataListApiData: [],
    HomeTutorViewDataListApiError: '',


    loadingHomeCategoryDataListApi: false,
    HomeCategoryDataListApiData: [],
    HomeCategoryDataListApiError: '',


    loadingCourseDataListApi: false,
    CourseDataListApiData: [],
    CourseDataListApiError: '',


    loadingProfileDataListApi: false,
    ProfileDataListApiData: [],
    ProfileDataListApiError: '',


    loadingSubCategoryListApi: false,
    SubCategoryListApiData: [],
    SubCategoryListApiError: '',


    loadingChildCategoryListApi: false,
    ChildCategoryListApiData: [],
    ChildCategoryListApiError: '',

    loadingTimeSlotDataListApi: false,
    TimeSlotDataListApiData: [],
    TimeSlotDataListApiError: '',

    loadingWebsiteSettingDataListApi: false,
    WebsiteSettingDataListApiData: [],
    WebsiteSettingDataListApiError: '',


    loadingCmsDataListApi: false,
    CmsDataListApiData: [],
    CmsDataListApiError: '',

    loadingGoogleMeetDataListApi: false,
    GoogleMeetDataListApiData: [],
    GoogleMeetDataListApiError: '',

    loadingAboutUsMainDataListApi: false,
    AboutUsMainDataListApiData: [],
    AboutUsMainDataListApiError: '',

    loadingAboutUsSecondSecDataListApi: false,
    AboutUsSecondSecDataListApiData: [],
    AboutUsSecondSecDataListApiError: '',

    loadingAboutUsThirdSecDataListApi: false,
    AboutUsThirdSecDataListApiData: [],
    AboutUsThirdSecDataListApiError: '',

    loadingAboutUsFourSecDataListApi: false,
    AboutUsFourSecDataListApiData: [],
    AboutUsFourSecDataListApiError: '',

    loadingAboutUsSixSecDataListApi: false,
    AboutUsSixSecDataListApiData: [],
    AboutUsSixSecDataListApiError: '',

    loadingChatroomListApi: false,
    ChatroomListApiData: [],
    ChatroomListApiError: '',


    loadingChatroomDetailApi: false,
    ChatroomDetailApiData: [],
    ChatroomDetailApiError: '',


    loadingMessageListApi: false,
    MessageListApiData: [],
    MessageListApiError: '',

    loadingHomeBannerDataApi: false,
    HomeBannerDataApiData: [],
    HomeBannerDataApiError: '',

    loadingHomeSecondSecDataApi: false,
    HomeSecondSecDataApiData: [],
    HomeSecondSecDataApiError: '',

    loadingHomeAboutNineSecDataApi: false,
    HomeAboutNineSecDataApiData: [],
    HomeAboutNineSecDataApiError: '',

    loadingHomeSixSecDataApi: false,
    HomeSixSecDataApiData: [],
    HomeSixSecDataApiError: '',


    loadingHomeSevenSecDataApi: false,
    HomeSevenSecDataApiData: [],
    HomeSevenSecDataApiError: '',

    loadingHomeFindTutorDataApi: false,
    HomeFindTutorDataApiData: [],
    HomeFindTutorDataApiError: '',

    loadingHomeBecomeTutorDataApi: false,
    HomeBecomeTutorDataApiData: [],
    HomeBecomeTutorDataApiError: '',


    loadingMeetingRecListDataApi: false,
    MeetingRecListDataApiData: [],
    MeetingRecListDataApiError: '',
    MeetingRecListCurrentPage: 0,
    MeetingRecListPerPageData: 0,
    MeetingRecListTotalData: 0,


}

const MasterReducer = (state = masterInitialState, action) => {
    switch (action.type) {

        case 'FETCH_HOME_CATEGORY_DATA_REQUEST':
            return {
                ...state,
                loadingCategoryDataListApi: true,
                CategoryDataListApiError: '',
            };
        case 'FETCH_HOME_CATEGORY_DATA_SUCCESS':
            return {
                ...state,
                loadingCategoryDataListApi: false,
                CategoryDataListApiData: action.payload,
            };
        case 'FETCH_HOME_CATEGORY_DATA_FAILURE':

            return {
                ...state,
                loadingCategoryDataListApi: false,
                CategoryDataListApiError: action.payload,
            };

        case 'FETCH_COUNTRY_DATA_REQUEST':
            return {
                ...state,
                loadingCountryDataListApi: true,
                CountryDataListApiError: '',
            };
        case 'FETCH_COUNTRY_DATA_SUCCESS':
            return {
                ...state,
                loadingCountryDataListApi: false,
                CountryDataListApiData: action.payload,
            };
        case 'FETCH_COUNTRY_DATA_FAILURE':

            return {
                ...state,
                loadingCountryDataListApi: false,
                CountryDataListApiError: action.payload,
            };

        case 'FETCH_STATE_DATA_REQUEST':
            return {
                ...state,
                loadingStateDataListApi: true,
                StateDataListApiError: '',
            };
        case 'FETCH_STATE_DATA_SUCCESS':
            return {
                ...state,
                loadingStateDataListApi: false,
                StateDataListApiData: action.payload,
            };
        case 'FETCH_STATE_DATA_FAILURE':

            return {
                ...state,
                loadingStateDataListApi: false,
                StateDataListApiError: action.payload,
            };
        case 'FETCH_CITY_DATA_REQUEST':
            return {
                ...state,
                loadingCityDataListApi: true,
                CityDataListApiError: '',
            };
        case 'FETCH_CITY_DATA_SUCCESS':
            return {
                ...state,
                loadingCityDataListApi: false,
                CityDataListApiData: action.payload,
            };
        case 'FETCH_CITY_DATA_FAILURE':

            return {
                ...state,
                loadingCityDataListApi: false,
                CityDataListApiError: action.payload,
            };



        case 'FETCH_WEBSITE_MANAGEMENT_DATA_REQUEST':
            return {
                ...state,
                loadingWebsiteManagementDataListApi: true,
                WebsiteManagementDataListApiError: '',
            };
        case 'FETCH_WEBSITE_MANAGEMENT_DATA_SUCCESS':
            return {
                ...state,
                loadingWebsiteManagementDataListApi: false,
                WebsiteManagementDataListApiData: action.payload,
            };
        case 'FETCH_WEBSITE_MANAGEMENT_DATA_FAILURE':

            return {
                ...state,
                loadingWebsiteManagementDataListApi: false,
                WebsiteManagementDataListApiError: action.payload,
            };


        case 'FETCH_POPULAR_TUTORS_DATA_REQUEST':
            return {
                ...state,
                loadingPopularTutorDataListApi: true,
                PopularTutorDataListApiError: '',
            };
        case 'FETCH_POPULAR_TUTORS_DATA_SUCCESS':
            return {
                ...state,
                loadingPopularTutorDataListApi: false,
                PopularTutorDataListApiData: action.payload,
            };
        case 'FETCH_POPULAR_TUTORS_DATA_FAILURE':

            return {
                ...state,
                loadingPopularTutorDataListApi: false,
                PopularTutorDataListApiError: action.payload,
            };



        case 'FETCH_TESTIMONIAL_DATA_REQUEST':
            return {
                ...state,
                loadingTestimonialDataListApi: true,
                TestimonialDataListApiError: '',
            };
        case 'FETCH_TESTIMONIAL_DATA_SUCCESS':
            return {
                ...state,
                loadingTestimonialDataListApi: false,
                TestimonialDataListApiData: action.payload,
            };
        case 'FETCH_TESTIMONIAL_DATA_FAILURE':

            return {
                ...state,
                loadingTestimonialDataListApi: false,
                TestimonialDataListApiError: action.payload,
            };


        case 'FETCH_BECOME_TUTOR_THIRD_SECTION_DATA_REQUEST':
            return {
                ...state,
                loadingBecomeTutorThirdSectionDataListApi: true,
                BecomeTutorThirdSectionDataListApiError: '',
            };
        case 'FETCH_BECOME_TUTOR_THIRD_SECTION_DATA_SUCCESS':
            return {
                ...state,
                loadingBecomeTutorThirdSectionDataListApi: false,
                BecomeTutorThirdSectionDataListApiData: action.payload,
            };
        case 'FETCH_BECOME_TUTOR_THIRD_SECTION_DATA_FAILURE':

            return {
                ...state,
                loadingBecomeTutorThirdSectionDataListApi: false,
                BecomeTutorThirdSectionDataListApiError: action.payload,
            };


        case 'FETCH_BLOG_DATA_REQUEST':
            return {
                ...state,
                loadingBlogDataListApi: true,
                BlogDataListApiError: '',
            };
        case 'FETCH_BLOG_DATA_SUCCESS':
            return {
                ...state,
                loadingBlogDataListApi: false,
                BlogDataListApiData: action.payload,
            };
        case 'FETCH_BLOG_DATA_FAILURE':

            return {
                ...state,
                loadingBlogDataListApi: false,
                BlogDataListApiError: action.payload,
            };


        case 'FETCH_BLOG_CATEGORY_DATA_REQUEST':
            return {
                ...state,
                loadingBlogCategoryDataListApi: true,
                BlogCategoryDataListApiError: '',
            };
        case 'FETCH_BLOG_CATEGORY_DATA_SUCCESS':
            return {
                ...state,
                loadingBlogCategoryDataListApi: false,
                BlogCategoryDataListApiData: action.payload,
            };
        case 'FETCH_BLOG_CATEGORY_DATA_FAILURE':

            return {
                ...state,
                loadingBlogCategoryDataListApi: false,
                BlogCategoryDataListApiError: action.payload,
            };


        case 'FETCH_LATEST_BLOG_DATA_REQUEST':
            return {
                ...state,
                loadingLatestBlogDataListApi: true,
                LatestBlogDataListApiError: '',
            };
        case 'FETCH_LATEST_BLOG_DATA_SUCCESS':
            return {
                ...state,
                loadingLatestBlogDataListApi: false,
                LatestBlogDataListApiData: action.payload,
            };
        case 'FETCH_LATEST_BLOG_DATA_FAILURE':

            return {
                ...state,
                loadingLatestBlogDataListApi: false,
                LatestBlogDataListApiError: action.payload,
            };


        case 'FETCH_BLOG_DETAIL_DATA_REQUEST':
            return {
                ...state,
                loadingBlogDetailDataListApi: true,
                BlogDetailDataListApiError: '',
            };
        case 'FETCH_BLOG_DETAIL_DATA_SUCCESS':
            return {
                ...state,
                loadingBlogDetailDataListApi: false,
                BlogDetailDataListApiData: action.payload,
            };
        case 'FETCH_BLOG_DETAIL_DATA_FAILURE':

            return {
                ...state,
                loadingBlogDetailDataListApi: false,
                BlogDetailDataListApiError: action.payload,
            };


        case 'FETCH_HOME_CATEGORY_DATA_REQUEST':
            return {
                ...state,
                loadingHomeCategoryDataListApi: true,
                HomeCategoryDataListApiError: '',
            };
        case 'FETCH_HOME_CATEGORY_DATA_SUCCESS':
            return {
                ...state,
                loadingHomeCategoryDataListApi: false,
                HomeCategoryDataListApiData: action.payload,
            };
        case 'FETCH_HOME_CATEGORY_DATA_FAILURE':

            return {
                ...state,
                loadingHomeCategoryDataListApi: false,
                HomeCategoryDataListApiError: action.payload,
            };

        case 'FETCH_HOME_TUTOR_LIST_DATA_REQUEST':
            return {
                ...state,
                loadingHomeTutorListDataListApi: true,
                HomeTutorListDataListApiError: '',
            };
        case 'FETCH_HOME_TUTOR_LIST_DATA_SUCCESS':
            return {
                ...state,
                loadingHomeTutorListDataListApi: false,
                HomeTutorListDataListApiData: action.payload,
            };
        case 'FETCH_HOME_TUTOR_LIST_DATA_FAILURE':

            return {
                ...state,
                loadingHomeTutorListDataListApi: false,
                HomeTutorListDataListApiError: action.payload,
            };

        case 'FETCH_COURSE_DATA_REQUEST':
            return {
                ...state,
                loadingCourseDataListApi: true,
                CourseDataListApiError: '',
            };
        case 'FETCH_COURSE_DATA_SUCCESS':
            return {
                ...state,
                loadingCourseDataListApi: false,
                CourseDataListApiData: action.payload,
            };
        case 'FETCH_COURSE_DATA_FAILURE':

            return {
                ...state,
                loadingCourseDataListApi: false,
                CourseDataListApiError: action.payload,
            };


        case 'FETCH_PROFILE_DATA_REQUEST':
            return {
                ...state,
                loadingProfileDataListApi: true,
                ProfileDataListApiError: '',
            };
        case 'FETCH_PROFILE_DATA_SUCCESS':
            return {
                ...state,
                loadingProfileDataListApi: false,
                ProfileDataListApiData: action.payload,
            };
        case 'FETCH_PROFILE_DATA_FAILURE':

            return {
                ...state,
                loadingProfileDataListApi: false,
                ProfileDataListApiError: action.payload,
            };



        case 'FETCH_SUB_CATEGORY_DATA_REQUEST':
            return {
                ...state,
                loadingSubCategoryListApi: true,
                SubCategoryListApiError: '',
            };
        case 'FETCH_SUB_CATEGORY_DATA_SUCCESS':
            return {
                ...state,
                loadingSubCategoryListApi: false,
                SubCategoryListApiData: action.payload,
            };
        case 'FETCH_SUB_CATEGORY_DATA_FAILURE':

            return {
                ...state,
                loadingSubCategoryListApi: false,
                SubCategoryListApiError: action.payload,
            };


        case 'FETCH_CHILD_CATEGORY_DATA_REQUEST':
            return {
                ...state,
                loadingChildCategoryListApi: true,
                ChildCategoryListApiError: '',
            };
        case 'FETCH_CHILD_CATEGORY_DATA_SUCCESS':
            return {
                ...state,
                loadingChildCategoryListApi: false,
                ChildCategoryListApiData: action.payload,
            };
        case 'FETCH_CHILD_CATEGORY_DATA_FAILURE':

            return {
                ...state,
                loadingChildCategoryListApi: false,
                ChildCategoryListApiError: action.payload,
            };


        case 'FETCH_TIME_SLOT_DATA_REQUEST':
            return {
                ...state,
                loadingTimeSlotDataListApi: true,
                TimeSlotDataListApiError: '',
            };
        case 'FETCH_TIME_SLOT_DATA_SUCCESS':
            return {
                ...state,
                loadingTimeSlotDataListApi: false,
                TimeSlotDataListApiData: action.payload,
            };
        case 'FETCH_TIME_SLOT_DATA_FAILURE':

            return {
                ...state,
                loadingTimeSlotDataListApi: false,
                TimeSlotDataListApiError: action.payload,
            };


        case 'FETCH_WEBSITE_SETTING_DATA_REQUEST':
            return {
                ...state,
                loadingWebsiteSettingDataListApi: true,
                WebsiteSettingDataListApiError: '',
            };
        case 'FETCH_WEBSITE_SETTING_DATA_SUCCESS':
            return {
                ...state,
                loadingWebsiteSettingDataListApi: false,
                WebsiteSettingDataListApiData: action.payload,
            };
        case 'FETCH_WEBSITE_SETTING_DATA_FAILURE':

            return {
                ...state,
                loadingWebsiteSettingDataListApi: false,
                WebsiteSettingDataListApiError: action.payload,
            };

        case 'FETCH_CMS_DATA_REQUEST':
            return {
                ...state,
                loadingCmsDataListApi: true,
                CmsDataListApiError: '',
            };
        case 'FETCH_CMS_DATA_SUCCESS':
            return {
                ...state,
                loadingCmsDataListApi: false,
                CmsDataListApiData: action.payload,
            };
        case 'FETCH_CMS_DATA_FAILURE':

            return {
                ...state,
                loadingCmsDataListApi: false,
                CmsDataListApiError: action.payload,
            };


        case 'FETCH_GOOGLE_MEET_DATA_REQUEST':
            return {
                ...state,
                loadingGoogleMeetDataListApi: true,
                GoogleMeetDataListApiError: '',
            };
        case 'FETCH_GOOGLE_MEET_DATA_SUCCESS':
            return {
                ...state,
                loadingGoogleMeetDataListApi: false,
                GoogleMeetDataListApiData: action.payload,
            };
        case 'FETCH_GOOGLE_MEET_DATA_FAILURE':

            return {
                ...state,
                loadingGoogleMeetDataListApi: false,
                GoogleMeetDataListApiError: action.payload,
            };


        case 'FETCH_ABOUT_US_MAIN_DATA_REQUEST':
            return {
                ...state,
                loadingAboutUsMainDataListApi: true,
                AboutUsMainDataListApiError: '',
            };
        case 'FETCH_ABOUT_US_MAIN_DATA_SUCCESS':
            return {
                ...state,
                loadingAboutUsMainDataListApi: false,
                AboutUsMainDataListApiData: action.payload,
            };
        case 'FETCH_ABOUT_US_MAIN_DATA_FAILURE':

            return {
                ...state,
                loadingAboutUsMainDataListApi: false,
                AboutUsMainDataListApiError: action.payload,
            };


        case 'FETCH_ABOUT_US_SECOND_SEC_DATA_REQUEST':
            return {
                ...state,
                loadingAboutUsSecondSecDataListApi: true,
                AboutUsSecondSecDataListApiError: '',
            };
        case 'FETCH_ABOUT_US_SECOND_SEC_DATA_SUCCESS':
            return {
                ...state,
                loadingAboutUsSecondSecDataListApi: false,
                AboutUsSecondSecDataListApiData: action.payload,
            };
        case 'FETCH_ABOUT_US_SECOND_SEC_DATA_FAILURE':

            return {
                ...state,
                loadingAboutUsSecondSecDataListApi: false,
                AboutUsSecondSecDataListApiError: action.payload,
            };

        case 'FETCH_ABOUT_US_THIRD_SEC_DATA_REQUEST':
            return {
                ...state,
                loadingAboutUsThirdSecDataListApi: true,
                AboutUsThirdSecDataListApiError: '',
            };
        case 'FETCH_ABOUT_US_THIRD_SEC_DATA_SUCCESS':
            return {
                ...state,
                loadingAboutUsThirdSecDataListApi: false,
                AboutUsThirdSecDataListApiData: action.payload,
            };
        case 'FETCH_ABOUT_US_THIRD_SEC_DATA_FAILURE':

            return {
                ...state,
                loadingAboutUsThirdSecDataListApi: false,
                AboutUsThirdSecDataListApiError: action.payload,
            };


        case 'FETCH_ABOUT_US_FOUR_SEC_DATA_REQUEST':
            return {
                ...state,
                loadingAboutUsFourSecDataListApi: true,
                AboutUsFourSecDataListApiError: '',
            };
        case 'FETCH_ABOUT_US_FOUR_SEC_DATA_SUCCESS':
            return {
                ...state,
                loadingAboutUsFourSecDataListApi: false,
                AboutUsFourSecDataListApiData: action.payload,
            };
        case 'FETCH_ABOUT_US_FOUR_SEC_DATA_FAILURE':

            return {
                ...state,
                loadingAboutUsFourSecDataListApi: false,
                AboutUsFourSecDataListApiError: action.payload,
            };


        case 'FETCH_ABOUT_US_SIX_SEC_DATA_REQUEST':
            return {
                ...state,
                loadingAboutUsSixSecDataListApi: true,
                AboutUsSixSecDataListApiError: '',
            };
        case 'FETCH_ABOUT_US_SIX_SEC_DATA_SUCCESS':
            return {
                ...state,
                loadingAboutUsSixSecDataListApi: false,
                AboutUsSixSecDataListApiData: action.payload,
            };
        case 'FETCH_ABOUT_US_SIX_SEC_DATA_FAILURE':

            return {
                ...state,
                loadingAboutUsSixSecDataListApi: false,
                AboutUsSixSecDataListApiError: action.payload,
            };


        case 'FETCH_CHATROOM_LIST_REQUEST':
            return {
                ...state,
                loadingChatroomListApi: true,
                ChatroomListApiError: '',
            };
        case 'FETCH_CHATROOM_LIST_SUCCESS':
            return {
                ...state,
                loadingChatroomListApi: false,
                ChatroomListApiData: action.payload,
            };
        case 'FETCH_CHATROOM_LIST_FAILURE':

            return {
                ...state,
                loadingChatroomListApi: false,
                ChatroomListApiError: action.payload,
            };


        case 'FETCH_CHATROOM_DETAIL_DATA_REQUEST':
            return {
                ...state,
                loadingChatroomDetailApi: true,
                ChatroomDetailApiError: '',
            };
        case 'FETCH_CHATROOM_DETAIL_DATA_SUCCESS':
            return {
                ...state,
                loadingChatroomDetailApi: false,
                ChatroomDetailApiData: action.payload,
            };
        case 'FETCH_CHATROOM_DETAIL_DATA_FAILURE':

            return {
                ...state,
                loadingChatroomDetailApi: false,
                ChatroomDetailApiError: action.payload,
            };



        case 'FETCH_MESSAGE_LIST_REQUEST':
            return {
                ...state,
                loadingMessageListApi: true,
                MessageListApiError: '',
            };
        case 'FETCH_MESSAGE_LIST_SUCCESS':
            return {
                ...state,
                loadingMessageListApi: false,
                MessageListApiData: action.payload,
            };
        case 'FETCH_MESSAGE_LIST_FAILURE':

            return {
                ...state,
                loadingMessageListApi: false,
                MessageListApiError: action.payload,
            };


        case 'FETCH_HOME_BANNER_DATA_REQUEST':
            return {
                ...state,
                loadingHomeBannerDataApi: true,
                HomeBannerDataApiError: '',
            };
        case 'FETCH_HOME_BANNER_DATA_SUCCESS':
            return {
                ...state,
                loadingHomeBannerDataApi: false,
                HomeBannerDataApiData: action.payload,
            };
        case 'FETCH_HOME_BANNER_DATA_FAILURE':

            return {
                ...state,
                loadingHomeBannerDataApi: false,
                HomeBannerDataApiError: action.payload,
            };

        case 'FETCH_HOME_SECOND_SEC_DATA_REQUEST':
            return {
                ...state,
                loadingHomeSecondSecDataApi: true,
                HomeSecondSecDataApiError: '',
            };
        case 'FETCH_HOME_SECOND_SEC_DATA_SUCCESS':
            return {
                ...state,
                loadingHomeSecondSecDataApi: false,
                HomeSecondSecDataApiData: action.payload,
            };
        case 'FETCH_HOME_SECOND_SEC_DATA_FAILURE':

            return {
                ...state,
                loadingHomeSecondSecDataApi: false,
                HomeSecondSecDataApiError: action.payload,
            };


        case 'FETCH_HOME_ABOUT_NINE_SEC_DATA_REQUEST':
            return {
                ...state,
                loadingHomeAboutNineSecDataApi: true,
                HomeAboutNineSecDataApiError: '',
            };
        case 'FETCH_HOME_ABOUT_NINE_SEC_DATA_SUCCESS':
            return {
                ...state,
                loadingHomeAboutNineSecDataApi: false,
                HomeAboutNineSecDataApiData: action.payload,
            };
        case 'FETCH_HOME_ABOUT_NINE_SEC_DATA_FAILURE':

            return {
                ...state,
                loadingHomeAboutNineSecDataApi: false,
                HomeAboutNineSecDataApiError: action.payload,
            };

        case 'FETCH_HOME_SIX_SEC_DATA_REQUEST':
            return {
                ...state,
                loadingHomeSixSecDataApi: true,
                HomeSixSecDataApiError: '',
            };
        case 'FETCH_HOME_SIX_SEC_DATA_SUCCESS':
            return {
                ...state,
                loadingHomeSixSecDataApi: false,
                HomeSixSecDataApiData: action.payload,
            };
        case 'FETCH_HOME_SIX_SEC_DATA_FAILURE':

            return {
                ...state,
                loadingHomeSixSecDataApi: false,
                HomeSixSecDataApiError: action.payload,
            };


        case 'FETCH_HOME_SEVEN_SEC_DATA_REQUEST':
            return {
                ...state,
                loadingHomeSevenSecDataApi: true,
                HomeSevenSecDataApiError: '',
            };
        case 'FETCH_HOME_SEVEN_SEC_DATA_SUCCESS':
            return {
                ...state,
                loadingHomeSevenSecDataApi: false,
                HomeSevenSecDataApiData: action.payload,
            };
        case 'FETCH_HOME_SEVEN_SEC_DATA_FAILURE':

            return {
                ...state,
                loadingHomeSevenSecDataApi: false,
                HomeSevenSecDataApiError: action.payload,
            };


            case 'FETCH_HOME_FIND_TUTOR_DATA_REQUEST':
                return {
                    ...state,
                    loadingHomeFindTutorDataApi: true,
                    HomeFindTutorDataApiError: '',
                };
            case 'FETCH_HOME_FIND_TUTOR_DATA_SUCCESS':
                return {
                    ...state,
                    loadingHomeFindTutorDataApi: false,
                    HomeFindTutorDataApiData: action.payload,
                };
            case 'FETCH_HOME_FIND_TUTOR_DATA_FAILURE':
    
                return {
                    ...state,
                    loadingHomeFindTutorDataApi: false,
                    HomeFindTutorDataApiError: action.payload,
                };


                case 'FETCH_HOME_BECOME_TUTOR_DATA_REQUEST':
                    return {
                        ...state,
                        loadingHomeBecomeTutorDataApi: true,
                        HomeBecomeTutorDataApiError: '',
                    };
                case 'FETCH_HOME_BECOME_TUTOR_DATA_SUCCESS':
                    return {
                        ...state,
                        loadingHomeBecomeTutorDataApi: false,
                        HomeBecomeTutorDataApiData: action.payload,
                    };
                case 'FETCH_HOME_BECOME_TUTOR_DATA_FAILURE':
        
                    return {
                        ...state,
                        loadingHomeBecomeTutorDataApi: false,
                        HomeBecomeTutorDataApiError: action.payload,
                    };


                    case 'FETCH_HOME_TUTOR_VIEW_DATA_REQUEST':
                        return {
                            ...state,
                            loadingHomeTutorViewDataListApi: true,
                            HomeTutorViewDataListApiError: '',
                        };
                    case 'FETCH_HOME_TUTOR_VIEW_DATA_SUCCESS':
                        return {
                            ...state,
                            loadingHomeTutorViewDataListApi: false,
                            HomeTutorViewDataListApiData: action.payload,
                        };
                    case 'FETCH_HOME_TUTOR_VIEW_DATA_FAILURE':
            
                        return {
                            ...state,
                            loadingHomeTutorViewDataListApi: false,
                            HomeTutorViewDataListApiError: action.payload,
                        };



                        case 'FETCH_MEETING_REC_DATA_REQUEST':
                            return {
                                ...state,
                                loadingMeetingRecListDataApi: true,
                                MeetingRecListDataApiError: '',
                            };
                        case 'FETCH_MEETING_REC_DATA_SUCCESS':
                            return {
                                ...state,
                                loadingMeetingRecListDataApi: false,
                                MeetingRecListDataApiData: action.payload? action.payload.data : [],
                                MeetingRecListCurrentPage: action.payload ? action.payload.pageInfo.currentPage : 1,
                                MeetingRecListPerPageData: action.payload ? action.payload.pageInfo.perPage : 1,
                                MeetingRecListTotalData: action.payload ? action.payload.pageInfo.total : 1,
                            };
                        case 'FETCH_MEETING_REC_DATA_FAILURE':
                
                            return {
                                ...state,
                                loadingMeetingRecListDataApi: false,
                                MeetingRecListDataApiError: action.payload,
                            };
                
                

        default:
            return state;
    }
}
export default MasterReducer;